import styled from '@emotion/styled'
import dayjs from 'dayjs'
import toast from 'react-hot-toast'

export default function Index() {
  return (
    <Container>
      <section className="footer">
        {/* <div className="block-1">
                <div className="contact-phone">
                  <div className='txt'>全国统一客服电话</div>
                  <div className='number'>400-622-6190</div>
                </div>
                <div className="join-us-btn">
                  <a href="#">加入我们</a>
                </div>
              </div> */}
        <div className="block-2">
          <div className="btn-group">
            {/* <a className='user-agreement' href='https://vip.meishubao.com/proto/'>
                    用户协议</a>
                  |
                  <a className='privacy-agreement' href='https://vip.meishubao.com/secret'>隐私协议</a>
                  | 
                <span className='btn-login'>登录</span> 
                <span>客服电话 400-622-6190</span>  */}
          </div>
          <div className="footer-desc">
            {/* 公司简介：美术宝1对1课程体系隶属于北京艺旗网络科技有限公司 公司地址：北京市朝阳区望京SOHOT1A座1005
                <br> */}
            <a href="http://www.17ms.com/">©2014-{dayjs().format('YYYY')} 北京艺旗网络科技有限公司/或其关联公司及特许人版权所有</a> |{' '}
            <a href={`${import.meta.env.VITE_APP_1v1h5_URL}/v2/civilizedInternet/`} target="_blank">
              文明上网倡议书
            </a>
            <div className="text-[12px] text-center text-[#ddd]">
              <span
                onClick={() => {
                  if (localStorage.STOP_ALL_RTC) {
                    localStorage.removeItem('STOP_ALL_RTC')
                    toast('调试模式: 关')
                  } else {
                    localStorage.STOP_ALL_RTC = 1
                    toast('调试模式: 开')
                  }
                }}
              >
                &ensp;
              </span>
              {import.meta.env.VITE_APP_TIME}
            </div>
          </div>
        </div>
      </section>
    </Container>
  )
}

const Container = styled.footer`
  background: #f5f5f5;
  padding-bottom: 20px;
  .footer {
    padding: 0;
    // height: 310px;
    width: 1200px;
    margin: 0 auto;
    min-width: 870px;
    .block-1 {
      padding: 20px 0;
      display: flex;
      border-bottom: 1px solid rgba(224, 224, 224, 1);
      .contact-phone {
        flex: 1;
        .txt {
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: rgba(0, 0, 0, 1);
        }

        .number {
          font-size: 30px;
          font-family: MicrosoftYaHei;
          font-weight: bold;
          color: rgba(0, 0, 0, 1);
        }
      }
      .join-us-btn {
        display: none;
        width: 240px;
        height: 64px;
        line-height: 64px;
        text-align: center;
        background: linear-gradient(-90deg, rgba(253, 101, 61, 1), rgba(252, 54, 59, 1));
        box-shadow: 0px 10px 20px 0px rgba(255, 51, 0, 0.17);
        opacity: 0.9;
        border-radius: 32px;
        cursor: pointer;
        font-size: 18px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);

        a {
          text-decoration: none;
          color: rgba(255, 255, 255, 1);
        }
      }
    }

    .block-2 {
      text-align: center;
      font-size: 14px;
      color: #808080;
      padding-top: 46px;
      // padding-bottom:48px;
      width: 100%;
      a {
        color: #808080;
        text-decoration: none;
        cursor: pointer;
      }

      .btn-login {
        color: #ff3300;
      }
    }
  }
`
